export default {
    methods: {
        stripHTML(value) {   
            const div = document.createElement('div')
            div.innerHTML = value
            const text = div.textContent || div.innerText || ''
            return text
            // return value.replace(/<\/?[^>]+(>|$)/g, '').replace(/(<.*?>)|\s+/g, (m, $1) => $1 ? $1 : ' ')
        },
        sentenceCase(value) {
            value = ( value === undefined || value === null ) ? '' : value;
            return value.toString().replace( /(^|\. *)([a-z])/g, (match, separator, char) => separator + char.toUpperCase())
        },
        isLoadingQuote(value) {
            this.$bus.$emit("loading-quote", value);
        },
        isLoading(value) {
            this.$bus.$emit("loading", value);
        },
        setVisibilityIconExtras(value) {
            let cookie = document.getElementsByClassName('cookie-affix')
            let support = document.getElementsByClassName('support-icon')
            cookie.length ? (value ? cookie[0].style.visibility = 'visible' : cookie[0].style.visibility = 'hidden') : null
            support.length ? (value ? support[0].style.visibility = 'visible' : support[0].style.visibility = 'hidden') : null
        },


        strip_char(text) {
            // /<[^>]+>/gm
            return text !== undefined && text != '' ? text.replace(/<(?!\/?(a|b|em|strong)(?=>|\s.*>))\/?.*?>/gm, '') : ''
        },
        getServRefCode(service) {
            let code = 'srq_typeqty_'
            code += service.prenType.replace(/ /g, '')
            code += service.prenCode.replace(/ /g, '')
            code += service.prenCodeSer.replace(/ /g, '')
            return code
        },
        getNight(date1,date2)
        {
            var dt1 = new Date(date1);
            var dt2 = new Date(date2);
            return  Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24))
        },
        stringify (v) {
            return this.filled(v.getDate()) + '/'+ this.filled(v.getMonth() * 1 + 1) +'/'+ v.getFullYear()
        },
        stringifyen (v) {    
           
            return v.getFullYear()+'-'+ this.filled(v.getMonth() * 1 + 1)+'-'+this.filled(v.getDate()) 
        },
        stringifyen2 (v) 
        {
            var date = v.split("/")
            return date[2]+'-'+date[1]+'-'+date[0] 
        },
        stringifyIT (v) {
            if(v)
            {
             var date = v.split("-")
             return date[2]+'/'+date[1]+'/'+date[0]
            } 
        },
        convertdatepIT (v) {
            if(v)
            {
             var date = v.split(".")
             return date[0]+'/'+date[1]+'/20'+date[2]
            } 
        },
        stringifyIT2 (v) {
            if(v)
            {
             var date = v.split("-")
             return date[2]+'/'+date[1]
            } 
        },
        stringifyIT3 (v) {
            if(v)
            {
             var date = v.split("-")
             return date[1]+'/'+date[2]+'/'+date[0]
            } 
        },
        plural(count,sing,plur)
        {
            if(count == 1) return sing
            else return plur
        },
        currencyFormatITe(num) 
        {
            if(num){
                return (
                    num.toFixed(2) // always two decimal digits
                    .replace('.', ',') // replace decimal point character with ,
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                ) // use . as a separator
            }
            else 
            {
                return 0
            }
        },
        currencyFormatIT(num) 
        {
            return (
                Math.round(num)
                .toFixed(2) // always two decimal digits
                .replace('.', ',') // replace decimal point character with ,
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            ) // use . as a separator
        },
        currencyFormatIT2(num) 
        {
            if(num){
                return (
                    Math.round(num)
                    .toFixed(0) // always two decimal digits
                    .replace('.', ',') // replace decimal point character with ,
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                ) // use . as a separator
            } else {
                return 0 ///????
            }
        },
        subDays(date,days) {
            var date = new Date(date);
            date.setDate(date.getDate() - days);
            return date;
        },
        addDays(date,days) {
            var date = new Date(date);
            
            date.setDate(date.getDate() + parseInt(days));
          
            return date;
        },
        getToday(){
            var today = new Date()
            return  today.getFullYear()+'-'+(today.getMonth() + 1).toString().padStart(2, "0")+'-'+ today.getDate().toString().padStart(2, "0")
        },
        filled (v) {
            return String(v).replace(/^(\d)$/, '0$1')
        },
        getDepByConnection(deptransp)
        {
            
            var dpt = deptransp.split('-')
            return dpt[0]
        },
        formatHour(hour,show1) {
            if(typeof show1 == 'undefined') show1 = false
            hour = hour.split(".")
            if(!hour[0].length) hour[0] = "00"
            if(hour[0].length && hour[0].length < 2) hour[0] = String(hour[0][0]).replace(/^(\d)$/, '0$1')+(hour[0].substr(1, hour[0].length))
             
            var rethour = hour[0]
            if(hour[1]) rethour+= ":"+ hour[1]  
          

            if(show1 && parseInt(show1.split('.')[0]) > parseInt(hour[0])) rethour+=' (+1) ' 
            return rethour
        },
        sortAssocKey( arr ) 
        {
            var keys = new Array();            
            for( var i in arr ) 
            keys.push(i);
            keys.sort();
            return keys
        /*var sortedArray = new Array();
        
        for( var i = 0; i < keys.length; i++ )  
        sortedArray[keys[i]] = arr[keys[i]];
        
        return sortedArray;*/
        },
        getParamsRooms(rooms)
        {   
            var params = ''
            rooms.forEach((val,index) => 
            {
                params+="&paxrooms["+index+"][ad]="+val.ad
                params+="&paxrooms["+index+"][ch]="+val.ch
                if(val.ch)
                {
                    params+="&paxrooms["+index+"][ages]=" + val.ages.join(",")
                }
            })
            
            return params
        },
        getParamsPacks(packs)
        {   
            let params = ''
            if(packs.land)  params+='land=1'
            if(packs.flies){
                if(params!= '') params+='&'
                params+='flies='+packs.flies.join(',')
            }
            if(packs.smartflies){
              
              if(params!= '') params+='&'
              params+='smartflies='+packs.smartflies.join(',')
            }
            if(packs.ships){
                if(params!= '') params+='&'
                params+='ships='+packs.ships.join(',')
            }
            return params
        },
        
        stripGS(value)
        {
            return value.replace('https://storage.googleapis.com/', '')
        },
        makeHtmlStar(stars,html)
        {
            if(typeof html === 'undefined') html='<i class="icon-star-full"></i>'
            
            var stars = (stars) ? stars.code.replace("TPSTAR_", "")  : 0            
            var starscontent =''
            for(let i=0;i<parseInt(stars);i++ )
            {
                starscontent+=html
            }
            // for(let i=parseInt(stars);i<5;i++ )
            // {
            //     starscontent+='<i class="fas fa-star c9 pl5"></i>'
            // }
            return starscontent
        },
        getLabelRoom(roomobj,details = true){
                
            let labelarray = {"ad":0,"ch":0,"nrooms":roomobj.length,"ages":""}
            let chlabel = ""
            let roomlabel = ""
            let roomlabel2 = ""
            let agelabel = ""
            
            
            if(roomobj && roomobj.length)
            {
                roomobj.forEach((val,index) => {
                    
                    labelarray.ad += parseInt(val.ad)
                    labelarray.ch += parseInt(val.ch)
                    
                    if(parseInt(val.ch))
                    {
                        
                        if(labelarray.ages) labelarray.ages+="," 
                        labelarray.ages += val.ages.join(",")
                    }
                })
                if(labelarray.ch)
                {
                    agelabel = "("+labelarray.ages+")"
                    chlabel = "+ "+labelarray.ch+" minor"+this.plural(labelarray.ch,"e","i")+" "+agelabel
                }
                if(labelarray.nrooms > 1)
                    roomlabel = "in "+ labelarray.nrooms+" camere"
                
                if(labelarray.nrooms > 1)
                    roomlabel2 = " / "+ labelarray.nrooms+" camere"

                this.roomslabelmin = labelarray.ad + labelarray.ch + " person"+this.plural(labelarray.ad + labelarray.ch,"a","e")+""+roomlabel2

                if(details)
                return (labelarray.ad + labelarray.ch + " person"+this.plural(labelarray.ad + labelarray.ch,"a","e")+" ("+labelarray.ad+ " adult"+this.plural(labelarray.ad,"o","i") +" "+chlabel+") " + roomlabel)
                else 
                return labelarray.ad + labelarray.ch + " person"+this.plural(labelarray.ad + labelarray.ch,"a","e")
            }
        },
        indexOfKeyValue(array,k,v)
        {
            if(array && array.length)
            {
                for (var i = 0; i < array.length; i++) 
                {
                    if(array[i][k] == v) return true
                }
            }
            return false
        },
        labelDestination(){
            var label = ''
                let destinations = this.$store.getters.destinations
                let destinationOptions = this.$store.getters.destOptions
                if(destinations && (destinations.strCodes.length || destinations.locations.length))
                {
                    
                    if(destinations.strCodes.length == 1 && !destinations.locations.length)
                    {
                        
                        destinations.strCodes.forEach((code,x)=>{
                        
                                
                                if(destinationOptions){
                                    destinationOptions.forEach((destopt,kx)=>{
                                        if(destopt.type == 'STR' && destopt.code == code){
                                            label += destopt.name                                
                                        }
                                    })
                                }
                         })
                    }
                    else if(!destinations.strCodes.length && destinations.locations.length == 1)
                    {
                        destinations.locations.forEach((loc,x)=>{
                        
                        label += loc
                         })
                    }
                    else
                    {
                        label = ''
                        if(destinations.strCodes.length)
                            label+= destinations.strCodes.length+' struttur'+this.plural(destinations.strCodes.length,"a","e")

                        if(destinations.locations.length)
                        {
                            if(label != '') label+=' e '
                            label+= destinations.locations.length+' destinazion'+this.plural(destinations.locations.length,"e","i")

                        }
                        
                    }
                    this.labeldest = ''
                    this.$store.getters.destinations.strCodes.forEach((code,x)=>{
                        
                        if(this.labeldest != '') this.labeldest+=' + '

                        if(destinationOptions){
                            destinationOptions.forEach((destopt,kx)=>{
                                if(destopt.type == 'STR' && destopt.code == code){
                                    this.labeldest += destopt.name                                
                                }
                            })
                        }
                    })
                    this.$store.getters.destinations.locations.forEach((loc,x)=>{
                        if(this.labeldest != '') this.labeldest+=' + '
                        this.labeldest += loc
                    })
                                       
                }
                
                return label
        },
        applyOperatorStringed(op,v1,v2)
        {
            if(op == "=") return (v1 == v2)
            if(op == ">") return (v1 > v2)
            if(op == "<") return (v1 < v2)
            if(op == "<=") return (v1 <= v2)
            if(op == ">=") return (v1 >= v2)
        },
        matchYoutubeUrl(url){
            var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
             return (url.match(p)) ? RegExp.$1 : false ;
        },
        isObject (value) {
            return value && typeof value === 'object' && value.constructor === Object;
        },
        scrollTo(element) {
            if(element.offsetTop) {
                window.scroll({
                    top: element.offsetTop, 
                    left: 0, 
                    behavior: 'smooth' 
                })
            } else {
                window.scroll({
                    top: document.querySelector(element).getBoundingClientRect().top, 
                    left: 0, 
                    behavior: 'smooth' 
                })
            }
        },
        startsWith(str, word) {
            return str.lastIndexOf(word, 0) === 0
        },
        dateDiff(date1,date2)
        {
            return this.getNight(date1,date2)
        },
        getTextByCode(texts,k)
        {
            let text = k
            for(var c in texts)
            {
                if(texts[c].title.toLowerCase() == k.toLowerCase())
                {
                    text = texts[c].text  
                }
                
                
            }
            return text
            

        },
        getConfigByName(configs,name)
        {
            for(var c in configs)
            {
                if(configs[c].name.toLowerCase() == name.toLowerCase())
                {
                  return configs[c].value  
                }
            }
        },
        string_to_slug(str, separator) {
            if(typeof separator === 'undefined') separator = '-'
            str = str.replace(/^\s+|\s+$/g, ""); // trim
            str = str.toLowerCase();
          
            // remove accents, swap ñ for n, etc
            var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
            var to = "aaaaaaeeeeiiiioooouuuunc------";
          
            for (var i = 0, l = from.length; i < l; i++) {
              str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
            }
          
            str = str.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-") // collapse dashes
            .replace(/^-+/, "") // trim - from start of text
            .replace(/-+$/, "") // trim - from end of text
            .replace(/-/g, separator);

          
            return str;
        },
        navbarOverModalDesktop() {
            this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
                const navbar = document.getElementsByTagName('header')[0];
                const dialog = bvEvent.vueTarget.$refs.dialog;
                if (dialog.classList.contains('modal-full') && window.innerWidth > 767) {
                    document.body.classList.add('navbar-visible-md');
                   // dialog.style.paddingTop = navbar.offsetHeight+'px';
                }
            });
            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                document.body.classList.remove('navbar-visible-md');
            });
        },
        isDef(value) {
            return typeof value !== 'undefined'
        },
        serialize(obj, prefix) {
            var str = [],
              p;
            for (p in obj) {
              if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p,
                  v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                  this.serialize(v, k) :
                  encodeURIComponent(k) + "=" + encodeURIComponent(v));
              }
            }
            return str.join("&")

          },
    }
}